/**
 * @author Mihail Sablin <mihail@webprogrammist.com>
 * @copyright Copyright (c) 2026, Mihail Sablin
 * @licence http://www.opensource.org/licenses/mit-license.php MIT licence
 */

import * as defaults from './defaults';
import * as utils from './basic';

import lightgallery from './../../../../../../node_modules/lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';

import {query, Query} from '@migelsabre/query/query';
import installEvents from '@migelsabre/query/events';

installEvents(Query);

import Modal from './modal.js';

import Consent from './policy';

//import {vPlayer} from "./player";

/**
 * @returns {Promise<vPlayer>}
 */
async function loadPlayer() {
	return await import('./player');
}

window.$ = jQuery;

// Уведомление об использовании Cookies
new Consent(document.getElementById('consent-popup'));

// Кнопка "Наверх" - скрытие/показ
const rewindButton = document.getElementById('rewind-button');
if (rewindButton) {
	const classes = rewindButton.classList;
	const handler = () => {
		classes.toggle('is-open', window.scrollY > defaults.SCROLL_THERSHOLD);
	};
	window.addEventListener('scroll', handler, {passive: true});
	rewindButton.addEventListener('click', () => window.scrollTo({top: 0, behavior: 'smooth'}));
	handler();
}

// "Шапка" сайта приклеивается к краю
const header = document.querySelector('.layout-header');
if (header) {
	window.addEventListener('scroll', () => {
		requestAnimationFrame(() => {
			header.classList.toggle('is-sticky', window.scrollY > 0);
		});
	}, {passive: true});
	requestAnimationFrame(() => {
		header.classList.toggle('is-sticky', window.scrollY > 0);
	});
}

// Переключатель способов оплаты на главной странице и "Помочь"
(() => {
	const tabNav = document.getElementById('pay-methods-nav');
	if (!tabNav) {
		return;
	}
	const activeTabId = window.location.hash;
	const tabs = tabNav.querySelectorAll('li > a.nav-button');
	const tabIds = Array.from(tabs).map(tab => tab.getAttribute('href')).filter(href => href && href.startsWith('#'));
	const contents = document.querySelectorAll('#pay-methods .card');
	if (tabs && contents) {
		tabNav.addEventListener('click', evt => {
			const tab = evt.target;
			if (!tab.matches('.nav-button')) {
				return;
			}
			let tabId = tab.getAttribute('href');
			if (!tabId.startsWith('#')) {
				return;
			}
			evt.preventDefault();
			tabId = tabId.substring(1);
			const activeTab = document.getElementById(tabId);
			if (!activeTab) {
				return;
			}
			requestAnimationFrame(() => {
				// Удаляем активный класс у всех табов и контента
				tabs.forEach(t => t.classList.remove('active'));
				contents.forEach(c => c.classList.remove('active'));

				// Добавляем активный класс текущему табу
				tab.classList.add('active');

				activeTab.classList.add('active');
			});
		});
		if (activeTabId && tabIds.includes(activeTabId)) {
			console.log(activeTabId);
			Array.from(tabs)
				.filter(t => t.getAttribute('href') === activeTabId)
				.forEach(t => t.dispatchEvent(new Event('click', {bubbles: true})));
		} else {
			tabs.item(0).dispatchEvent(new Event('click', {bubbles: true}));
		}
	}
})();

// Видео-плеер
const videoElements = query('video.video-js');
if (videoElements && videoElements.length) {
	const vPlayer = loadPlayer().then(module => {
		const {vPlayer} = module;
		videoElements.forEach(el => {
			if (el.closest('template')) {
				return;
			}
			new vPlayer(el);
		});
	});
}


// Открытие QR-кода в "подвале" на полный экран

const toggleQr = document.getElementById('qr-code-footer-toggle');
const qr = document.getElementById('qr-code-footer');
if (toggleQr && qr) {
	const gallery = lightgallery(toggleQr, {
		dynamic: true,
		dynamicEl: [{
			src: qr.getAttribute('src')
		}],
		plugins: []
	});
	toggleQr.addEventListener('click', evt => {
		gallery.openGallery(0);
	});
}


// lightgallery для картинок
const lightgalleryContainer = document.getElementById('donate-app-container');
if (lightgalleryContainer) {
	lightgallery(lightgalleryContainer, {
		selector: 'a',
	});
}

// "Отчеты" - выбор года и показ соотв. списка документов
(() => {
	const navContainer = query('#reports-year-nav');
	const listContainer = query('#reports-year-document-list');
	if (navContainer.length && listContainer.length) {
		const buttons = navContainer.query('.list-item');
		const items = listContainer.query('li.year-document-list-item');
		buttons.on('click', evt => {
			evt.preventDefault();
			let id = evt.target.getAttribute('href');
			requestAnimationFrame(() => {
				items.forEach(item => {
					item.style.display = 'none';
				});
				document.getElementById(id.slice(1)).style.display = '';
			});
		});
		items.forEach(item => {
			item.style.display = 'none';
		});
	}
})();

// картинки на главной - блок "О нас"
query('section.hero.hero-about').query('.gallery').forEach(element => {
	lightgallery(element, {
		selector: 'a',
	});
});

const campaignList = document.getElementById('campaign-list');
if (campaignList) {
	loadPlayer().then(module => {
		const {vPlayer} = module;
		campaignList.querySelectorAll('.card .card-footer .btn').forEach(el => {
			let href = el.getAttribute('href');
			if(href === '#') {
				el.addEventListener('click', evt => {
					evt.preventDefault();
					const card = el.closest('.card');
					if (!card) {
						return;
					}
					const html = card.querySelector('template');
					const title = card.querySelector('.card-title')?.textContent;
					if (html) {
						Modal.show(html, {
							title: title || '',
							showCloseButton: true,
							onOpen: (modal) => {

								Array.from(modal.contentElement.querySelectorAll('video.video-js') || [])
									.filter(el => {
										return !el.classList.contains('vjs-player')
									})
									.forEach(el => {
										new vPlayer(el);
									});
								vPlayer.pauseAll();
							},
							onClose: (modal) => {
								vPlayer.pauseAll();
							}
						});
					}
				});
			}
		});
	});
}
